import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import config from "../../../config";
import {
  handleAccept,
  handleClose,
  handleEdit,
  handlePause,
  handleReactivate,
  handleReopen,
} from "../../../utils/Problem/problemHandlers";
import { ProblemData } from "../../../utils/Problem/problemTypes";
import "../Modal.css";
import ConfirmCloseModal from "./ConfirmClose";
import JournalModal from "./JournalModal";
import CommunicationModal from "./CommunicationModel";
import ProblemForward from "./ProblemForward";
import { authFetch } from "../../../utils/Security/authFetch";
const isAdmin = localStorage.getItem("isAdmin") === "true";

type Message = {
  id: number;
  username: string;
  message: string;
  date: string;
};
type Communication = {
  id: number;
  users: string;
  message: string;
  date: string;
};

type ModalProps = {
  isOpen: boolean;
  data: any;
  onClose: () => void;
};

const hiddenKeys = [
  "isaccepted",
  "isFavorite",
  "isallsite",
  "isclosed",
  "foruserid",
  "userid",
  "isforwarded",
  "isreopened",
  "isreactivated",
];

// Sections
const ticketInfo = [
  "createdby",
  "userid",
  "ticketId",
  "problemStartDatetime",
  "problemCloseDatetime",
  "ticketCreationDatetime",
  "ticketClosureDatetime",
  "status",
];
const customerInfo = [
  "affectedCustomer",
  "affectedNetwork",
  "affectedSite",
  "affectedLink",
  "asset",
];
const slaInfo = [
  "sla",
  "slaStatus",
  // "ola",
  // "olaStatus",
  // "reactionPoint",
];
const statusInfo = [
  "summary",
  "description",
  "solution",
  "closureCode",
  "errorType",
];
const resInfo = ["responsibleTeam", "responsiblePerson"];
const miscInfo = ["journalUpdate", "changetemplate", "filePath"];
const incInfo = ["urgency", "impact", "priority"];

const relInfo = ["relatedobject", "filePath"];

const fieldLabels: { [key: string]: string } = {
  // Ticket Info
  createdby: "Created By",
  userid: "User ID",
  ticketId: "Ticket ID",
  status: "Status",
  ticketCreationDatetime: "Problem Creation Date/Time",
  ticketClosureDatetime: "Problem Closure Date/Time",
  problemStartDatetime: "Problem Start Date/Time",
  problemCloseDatetime: "Problem End Date/Time",
  customerComplaint: "Customer Complaint",
  customerInformed: "Customer Informed",
  problemCrossReference: "Problem Cross Reference",

  // Customer Info
  affectedCustomer: "Customer",
  affectedSite: "Site",
  affectedNetwork: "Network",
  affectedLink: "Link",
  asset: "Asset",

  // SLA Info
  sla: "SLA",
  slaStatus: "SLA Status",
  ola: "OLA",
  olaStatus: "OLA Status",
  reactionPoint: "Reaction Point",
  responseTimeToOpen: "Response Time to Open",
  responseTimeToClose: "Response Time to Close",

  // Status Info
  summary: "Summary",
  description: "Description",
  solution: "Solution",
  closureCode: "Closure Code",
  errorType: "Error Type",

  // Responsible
  responsiblePerson: "Responsible Person",
  responsibleTeam: "Responsible Team",

  // Misc
  journalUpdate: "Journal Update",
  changetemplate: "Change Template",
  attachments: "Attachments",

  // Incident Info
  impact: "Impact",
  priority: "Priority",
  urgency: "Urgency",

  // Related Info
  relatedobject: "Related Object",
  attachment: "Attachment",
  filePath: "File Attachment",
};
const formatDate = (dateStr: string): string => {
  if (!dateStr) return "";
  // Replace "T" with space and remove fractional seconds (e.g. .927666)
  return dateStr.replace("T", " ").replace(/\.\d+$/, "");
};

const renderAttachment = (filePaths: string[] | undefined) => {
  if (!filePaths || filePaths.length === 0) return null;

  const handleDownload = async (filePath: string, extension: string) => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      alert("You need to sign in to download this file.");
      return;
    }

    try {
      const url = `http://149.202.42.77:8080/${filePath.replace(/\\/g, "/")}`;
      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        alert("Failed to download file. Please sign in.");
        return;
      }

      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = downloadUrl;
      a.download = filePath.split("/").pop() || `file.${extension}`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error("Download error:", error);
      alert("Error downloading file.");
    }
  };

  return (
    <>
      {filePaths.map((filePath, index) => {
        const token = localStorage.getItem("authToken");
        const extension = filePath.split(".").pop()?.toLowerCase();

        if (!extension) return null;

        if (["png", "jpg", "jpeg", "gif", "bmp"].includes(extension)) {
          const url = `http://149.202.42.77:8080/${filePath.replace(
            /\\/g,
            "/"
          )}?token=${token}`;
          return (
            <img
              key={index}
              src={url}
              alt="attachment"
              style={{
                maxWidth: "100%",
                maxHeight: 300,
                display: "block",
                marginBottom: 10,
              }}
            />
          );
        }

        if (extension === "pdf") {
          const url = `http://149.202.42.77:8080/${filePath.replace(
            /\\/g,
            "/"
          )}?token=${token}`;
          return (
            <iframe
              key={index}
              src={url}
              title={`PDF-${index}`}
              style={{
                width: "100%",
                height: "500px",
                border: "none",
                marginBottom: 10,
              }}
            />
          );
        }

        return (
          <button
            key={index}
            onClick={() => handleDownload(filePath, extension)}
            style={{
              display: "block",
              marginBottom: 10,
              backgroundColor: "#007bff",
              color: "white",
              border: "none",
              padding: "6px 12px",
              cursor: "pointer",
              borderRadius: 4,
            }}
          >
            Download attachment ({extension.toUpperCase()})
          </button>
        );
      })}
    </>
  );
};
const Modal: React.FC<ModalProps> = ({ isOpen, data, onClose }) => {
  console.log("0provlemmm", data);
  const navigate = useNavigate();
  const [selectedProblem, setSelectedProblem] = useState<ProblemData | null>(
    null
  );
  const [pauseAfterJournal, setPauseAfterJournal] = useState(false); // 🟢 new state
  const [journalTitle, setJournalTitle] = useState("Add Journal");

  const [localProblemData, setLocalProblemData] = useState<any>(data);
  const isAdmin = localStorage.getItem("isAdmin") === "true";
  const [isForwardModalOpen, setIsForwardModalOpen] = useState(false);
  const [journalMessages, setJournalMessages] = useState<Message[]>([]);
  const [communicationMessages, setCommunicationMessages] = useState<
    Communication[]
  >([]);
  const [showConfirmClose, setShowConfirmClose] = useState(false);
  const [ShowJournal, setShowJournal] = useState(false);
  const [ShowCommunication, setShowCommunication] = useState(false);
  const [fileImages, setFileImages] = useState<{
    [path: string]: string | null;
  }>({});
  const downloadFile = async (path: string) => {
    try {
      if (!path) return;
      const normalizedPath = path.replace(/\\/g, "/");
      const originalFileName = normalizedPath.split("/").pop();
      if (!originalFileName) return;

      const res = await authFetch(
        `${
          config.apiBaseUrl
        }/api/problems/downloadFile?path=${encodeURIComponent(path)}`
      );
      if (!res.ok) throw new Error("Failed to download file");

      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = originalFileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Download error:", err);
    }
  };
  const renderSection = (title: string, keys: string[], data: any) => (
    <div className="modal-section">
      <h3>{title}</h3>
      <div className="modal-section-content">
        {keys
          .filter(
            (key) =>
              data[key] !== undefined &&
              !hiddenKeys.includes(key) &&
              (isAdmin ||
                ![
                  "reactionPoint",
                  "responseTimeToOpen",
                  "responseTimeToClose",
                  "impact",
                  "priority",
                  "acceptanceTime",
                  "sla",
                  "slaStatus",
                  "relatedobject",
                  "ola",
                  "olaStatus",
                  "incidentCrossReference",
                  "customerComplaint",
                  "customerInformed",
                ].includes(key))
          )
          .map((key, index) => (
            <div key={index} className="modal-item">
              <strong>{fieldLabels[key] || key}:</strong>
              <div className="modal-value">
                {key === "filePath" ? (
                  Array.isArray(data[key]) ? (
                    <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                      {data[key].map((path: string | null, i: number) => {
                        if (!path) return null;

                        const normalizedPath = path.replace(/\\/g, "/");
                        const fileName =
                          normalizedPath.split("/").pop() || `File${i + 1}`;
                        const ext = fileName.split(".").pop()?.toLowerCase();
                        const isImage = [
                          "png",
                          "jpg",
                          "jpeg",
                          "gif",
                          "bmp",
                          "webp",
                        ].includes(ext || "");
                        const imgUrl = fileImages[path] || null;

                        return (
                          <li key={i} style={{ marginBottom: "10px" }}>
                            {isImage && imgUrl ? (
                              <img
                                src={imgUrl}
                                alt={fileName}
                                style={{
                                  maxWidth: "100%",
                                  maxHeight: "300px",
                                  borderRadius: "5px",
                                }}
                              />
                            ) : (
                              <button
                                style={{
                                  color: "blue",
                                  textDecoration: "underline",
                                  background: "none",
                                  border: "none",
                                  cursor: "pointer",
                                }}
                                onClick={() => downloadFile(path)}
                              >
                                {fileName}
                              </button>
                            )}
                          </li>
                        );
                      })}
                    </ul>
                  ) : (
                    (() => {
                      const normalizedPath =
                        data[key]?.replace(/\\/g, "/") || "";
                      const fileName =
                        normalizedPath.split("/").pop() || "file";
                      const ext = fileName.split(".").pop()?.toLowerCase();
                      const isImage = [
                        "png",
                        "jpg",
                        "jpeg",
                        "gif",
                        "bmp",
                        "webp",
                      ].includes(ext || "");
                      const fileUrl = `${config.apiBaseUrl}/api/problems/files/${fileName}`;

                      return isImage ? (
                        <img
                          src={fileUrl}
                          alt={fileName}
                          style={{
                            maxWidth: "100%",
                            maxHeight: "300px",
                            borderRadius: "5px",
                          }}
                        />
                      ) : (
                        <button
                          style={{
                            color: "blue",
                            textDecoration: "underline",
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                          }}
                          onClick={() => downloadFile(data[key])}
                        >
                          {fileName}
                        </button>
                      );
                    })()
                  )
                ) : key === "userid" ? (
                  ""
                ) : key === "relatedobject" && data[key] ? (
                  (Array.isArray(data[key])
                    ? data[key]
                    : (data[key] as string).split(",")
                  ).map((item: string, idx: number) => {
                    const ticketId = item.trim();
                    let path = `/incident-edit/${ticketId}`; // default

                    if (ticketId.startsWith("TSK"))
                      path = `/task-edit/${ticketId}`;
                    else if (ticketId.startsWith("CHN"))
                      path = `/change-edit/${ticketId}`;
                    else if (ticketId.startsWith("IND"))
                      path = `/incident-edit/${ticketId}`;

                    return (
                      <React.Fragment key={idx}>
                        <button
                          style={{
                            color: "blue",
                            textDecoration: "underline",
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                            padding: 0,
                            marginRight: 5,
                          }}
                          onClick={() => navigate(path, { state: { data } })}
                        >
                          {ticketId}
                        </button>
                        {idx <
                        (Array.isArray(data[key])
                          ? data[key].length
                          : (data[key] as string).split(",").length) -
                          1
                          ? ", "
                          : ""}
                      </React.Fragment>
                    );
                  })
                ) : Array.isArray(data[key]) ? (
                  data[key].join(", ")
                ) : typeof data[key] === "string" ? (
                  ["description", "summary", "solution"].includes(key) ? (
                    <div
                      dangerouslySetInnerHTML={{ __html: data[key] }}
                      style={{ whiteSpace: "normal" }}
                    />
                  ) : /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(data[key]) ? (
                    formatDate(data[key])
                  ) : (
                    data[key]
                  )
                ) : (
                  JSON.stringify(data[key], null, 2)
                )}
              </div>
            </div>
          ))}
      </div>
    </div>
  );

  useEffect(() => {
    if (isOpen) {
      setLocalProblemData(data);
      fetchMessages();
      fetchCommunication();
    }
  }, [isOpen, data]);
  const handleJournalConfirm = async () => {
    if (pauseAfterJournal) {
      await handlePause(data, fetchMessages);
    }
    setPauseAfterJournal(false);
    setShowJournal(false);
    onClose();
  };
  const handlePauseWithJournal = () => {
    setPauseAfterJournal(true);
    setJournalTitle("Pause Problem (Add Journal)");
    setShowJournal(true);
  };
  const closeForwardModal = () => {
    setIsForwardModalOpen(false);
    setSelectedProblem(null);
  };
  const fetchMessages = async () => {
    if (!data?.ticketId) return;
    const res = await authFetch(
      `${config.apiBaseUrl}/api/messages/ticket/${data.ticketId}`
    );
    if (res.ok) setJournalMessages(await res.json());
  };

  const fetchCommunication = async () => {
    if (!data?.ticketId) return;
    const res = await authFetch(
      `${config.apiBaseUrl}/api/communications/ticket/${data.ticketId}`
    );
    if (res.ok) setCommunicationMessages(await res.json());
  };

  if (!isOpen) return null;

  const isAccepted = data?.isaccepted;
  const isClosed = data?.isclosed;
  const isPaused = data?.ispaused;
  const handleForward = (data: ProblemData) => {
    setSelectedProblem(data);
    setIsForwardModalOpen(true);
  };
  const fetchUpdatedRma = async (): Promise<ProblemData> => {
    const res = await authFetch(
      `${config.apiBaseUrl}/api/problems/${data.ticketId}`
    );
    console.log("res.json>>>", res.json);
    return await res.json();
  };
  const confirmClose = async () => {
    setShowConfirmClose(false);
    onClose();
    await new Promise((resolve) => setTimeout(resolve, 3000));
    const updatedData = await fetchUpdatedRma();
    await handleClose(updatedData, fetchMessages);
  };

  const addjournal = () => {
    handlePause(data, fetchMessages);
    setShowJournal(false);
    onClose();
  };
  const addcommunication = () => {
    setShowCommunication(false);
    onClose();
  };

  return (
    <>
      {isForwardModalOpen && (
        <ProblemForward
          isOpen={isForwardModalOpen}
          data={selectedProblem}
          onClose={closeForwardModal}
        />
      )}

      {showConfirmClose && (
        <ConfirmCloseModal
          data={data}
          onConfirm={confirmClose}
          onCancel={() => setShowConfirmClose(false)}
        />
      )}

      {ShowJournal && (
        <JournalModal
          title={journalTitle}
          data={data}
          onConfirm={handleJournalConfirm}
          onCancel={() => {
            setPauseAfterJournal(false);
            setShowJournal(false);
          }}
        />
      )}

      {ShowCommunication && (
        <CommunicationModal
          data={data}
          onConfirm={addcommunication}
          onCancel={() => setShowCommunication(false)}
        />
      )}

      <div className="modal-overlay">
        <div className="modal-content">
          <div
            className="modal-top-buttons"
            style={{
              position: "sticky",
              top: -32,
              backgroundColor: "#fff",
              zIndex: 100,
              padding: "10px",
              display: "flex",
              flexWrap: "wrap",
              gap: "10px",
            }}
          >
            {!isClosed && (
              <button
                onClick={() => navigate(`/problem-edit/${data.ticketId}`)}
              >
                Edit
              </button>
            )}
            {!isAccepted && isAdmin && (
              <button onClick={() => handleAccept(data, fetchMessages)}>
                Accept
              </button>
            )}
            {isAccepted && !isPaused && !isClosed && isAdmin && (
              <>
                <button disabled>Already Accepted</button>
                <button onClick={handlePauseWithJournal}>Pause</button>
                <button onClick={() => setShowConfirmClose(true)}>Close</button>
              </>
            )}
            {isPaused && isAdmin && (
              <>
                <button onClick={() => handleReactivate(data, fetchMessages)}>
                  Reactivate
                </button>
                <button onClick={() => setShowConfirmClose(true)}>Close</button>
              </>
            )}
            {isClosed && isAdmin && (
              <button onClick={() => handleReopen(data, fetchMessages)}>
                Reopen
              </button>
            )}
            {isAdmin && !isClosed && (
              <button onClick={() => handleForward(data)}>Forward</button>
            )}
            <button onClick={onClose}>X</button>
          </div>

          <h2
            style={{
              position: "sticky",
              top: 16, // slightly below the buttons
              backgroundColor: "#fff",
              zIndex: 99,
              margin: 0,
              padding: "10px 0",
            }}
          >
            Problem Details
          </h2>
          <div className="modal-body">
            {renderSection("Problem Information", ticketInfo, data)}
            {renderSection("Customer & Network", customerInfo, data)}
            {renderSection("Problem Severity", incInfo, data)}
            {renderSection("Problem Details", statusInfo, data)}
            {renderSection("Responsibility", resInfo, data)}
            {isAdmin && renderSection("SLA", slaInfo, data)}
            {isAdmin && renderSection("Related Object", relInfo, data)}
          </div>

          <div className="messages-container">
            <div className="journal">
              {isAdmin && (
                <button
                  onClick={() => {
                    setPauseAfterJournal(false);
                    setJournalTitle("Add Journal");
                    setShowJournal(true);
                  }}
                >
                  Add Journal
                </button>
              )}
              <h3>Journal</h3>
              <ul>
                {[...journalMessages]
                  .sort(
                    (a, b) =>
                      new Date(b.date).getTime() - new Date(a.date).getTime()
                  )
                  .map((msg) => (
                    <li key={msg.id}>
                      <strong>{msg.username}</strong>:{" "}
                      <span
                        dangerouslySetInnerHTML={{ __html: msg.message }}
                        style={{
                          display: "inline-block",
                          maxWidth: "100%",
                          wordWrap: "break-word",
                          overflowWrap: "break-word",
                        }}
                      />
                      <br />
                      <small>{new Date(msg.date).toLocaleString()}</small>
                    </li>
                  ))}
              </ul>
            </div>

            {/* <div className="journal">
              <button onClick={() => setShowCommunication(true)}>
                Add Communication
              </button>

              <h3>Communication</h3>
              <ul>
                {[...communicationMessages]
                  .sort(
                    (a, b) =>
                      new Date(b.date).getTime() - new Date(a.date).getTime()
                  )
                  .map((msg) => (
                    <li key={msg.id}>
                      <strong>{msg.users}</strong>: {msg.message}
                      <br />
                      <small>{new Date(msg.date).toLocaleString()}</small>
                    </li>
                  ))}
              </ul>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Modal;
